/* ============
 * releaseNote Transformer
 * ============
 */

import Transformer from './transformer';

export default class ReleaseNotesTransformer extends Transformer {

  static fetch(releaseNote) {
    return {
      id: releaseNote.id,
      title: releaseNote.title,
      description: releaseNote.description,
      module: releaseNote.module,
      version: releaseNote.version,
      commit: releaseNote.commit,
      releaseSilent: releaseNote.release_silent,
      createdAt: releaseNote.created_at,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/releaseNote.js